module.exports = __webpack_public_path__ + "img/register-header.18f2a623.png";